export const REQUEST_CUSTOMER_TESTIMONIALS_DATA = 'REQUEST_CUSTOMER_TESTIMONIALS_DATA';
export const RECEIVE_CUSTOMER_TESTIMONIALS_DATA = 'RECEIVE_CUSTOMER_TESTIMONIALS_DATA';

export const receiveCustomerTestimonialsData = (payload) => ({
  type: RECEIVE_CUSTOMER_TESTIMONIALS_DATA,
  payload: payload
});



// WEBPACK FOOTER //
// ./src/actions/customerTestimonialsActions.js